import { tv } from 'tailwind-variants';
import { focusStyles } from '../../styles/focusStyles.esm.js';

const actionChipStyles = tv({
    slots: {
        base: `
      iris:group
      iris:block
      iris:cursor-pointer
      iris:overflow-hidden
      iris:rounded-(--comp-size-radius-chip-action)
      iris:border-(length:--comp-size-border-chip-action)
      iris:border-transparent
      iris:font-(family-name:--comp-type-font-chip-action)
      iris:text-(length:--comp-type-size-chip-action)
      iris:leading-(--comp-type-leading-chip-action)
      iris:font-(--comp-type-weight-chip-action)!
      iris:tracking-(--comp-type-tracking-chip-action)
      iris:duration-(--comp-motion-duration-chip-action)
      iris:ease-(--comp-motion-easing-chip-action)

    `,
        wrapper: `
      iris:inline-flex
      iris:h-(--comp-size-height-chip-action)
      iris:min-h-[32px]
      iris:w-full
      iris:min-w-[32px]
      iris:items-center
      iris:px-(--comp-space-padding-chip-action-horizontal)
      iris:py-(--comp-space-padding-chip-action-vertical)
      iris:transition-all
      iris:duration-(--comp-motion-duration-chip-action)
      iris:ease-(--comp-motion-easing-chip-action)
    `,
    },
    variants: {
        inverse: {
            false: {
                base: `
          ${focusStyles.default} 
          iris:border-(--comp-color-border-chip-action-rest)
          iris:bg-(--comp-color-background-chip-action-rest)
          iris:hover:border-(--comp-color-border-chip-action-hover)
          iris:active:border-(--comp-color-border-chip-action-pressed)
        `,
                wrapper: `
          iris:text-(--comp-color-content-chip-action-label-rest)
          iris:group-hover:bg-(--comp-color-background-chip-action-hover)
          iris:group-hover:text-(--comp-color-content-chip-action-label-hover)
          iris:group-active:bg-(--comp-color-background-chip-action-pressed)
          iris:group-active:text-(--comp-color-content-chip-action-label-pressed)
        `,
            },
            true: {
                base: `
          ${focusStyles.inverse}
          iris:border-(--comp-color-border-chip-action-inverse-rest)
          iris:bg-(--comp-color-background-chip-action-inverse-rest)
          iris:hover:border-(--comp-color-border-chip-action-inverse-hover)
          iris:active:border-(--comp-color-border-chip-action-inverse-pressed)
        `,
                wrapper: `
          iris:text-(--comp-color-content-chip-action-label-inverse-rest)
          iris:group-hover:bg-(--comp-color-background-chip-action-inverse-hover)
          iris:group-hover:text-(--comp-color-content-chip-action-label-inverse-hover)
          iris:group-active:bg-(--comp-color-background-chip-action-inverse-pressed)
          iris:group-active:text-(--comp-color-content-chip-action-label-inverse-pressed)
        `,
            },
        },
        disabled: {
            true: {
                base: `
          iris:pointer-events-none
          iris:cursor-not-allowed
          iris:opacity-(--sem-opacity-interactive-disabled)
        `,
            },
        },
    },
    defaultVariants: {
        inverse: false,
        disabled: false,
    },
});

export { actionChipStyles as default };
